import { Card } from '@ps/isp-web-component-library';
import React from 'react';

import type { MultipleReceiptItem, SingleReceiptItem } from '@swf/core/models/sports/betSlip/types';

import { isSingleReceiptItem } from '../../../../../../../../utils/isReceiptItem';

import BetDetails from './BetDetails/BetDetails';
import MultipleAccordion from './MultipleAccordion/MultipleAccordion';
import styles from './ReceiptItem.scss';
import StakeAndReturns from './StakeAndReturns/StakeAndReturns';

interface Props {
  receiptItem: SingleReceiptItem | MultipleReceiptItem;
}

const ReceiptItem: React.FC<Props> = ({ receiptItem }) => {
  if (isSingleReceiptItem(receiptItem)) {
    return (
      <Card isPadded>
        <div className={styles.betDetails}>
          <BetDetails
            {...receiptItem}
            isEventInPlay={receiptItem.eventInPlay}
            isEachWaySelected={receiptItem.eachWaySelected}
            odds={receiptItem.legs?.[0].winOdds}
          />
        </div>

        <StakeAndReturns receiptItem={receiptItem} />
      </Card>
    );
  }

  return (
    <div className={styles.betDetails}>
      <MultipleAccordion {...receiptItem} />
    </div>
  );
};

export default ReceiptItem;
